module.exports = __webpack_public_path__ + "img/technologyBox.d89119ec.png";